module.exports = __webpack_public_path__ + "img/图片2.fea1ff20.png";